<div class="editable-side-panel-input-coordinate"
  [class]="subtype"
  [formGroup]="getFormGroup()">

  <!-- OPTIONAL ICON -->
  <div class="icon-wrapper">
    @if (iconName) {
      <mat-icon [svgIcon]="iconName">
      </mat-icon>
    }
  </div>

  <div class="flex flex-col mt-[16px] w-full">
    <span class="text-label-large text-neutral-10 ml-[8px] mb-[8px]">
      {{getFieldName(fieldId)}}
    </span>

    <!-- MAT FORM FIELDS -->
    <!-- Use htmlType='text' to prevent decimal separator variations because of browser language -->

    <!-- LATITUDE -->
    <app-editable-textual-input [formGroupNameRef]="fieldId"
      [fieldId]="'latitude'"
      [isFieldWithDataSource]="isFieldWithDataSource"
      [hasActiveConnection]="isFieldWithDataSource"
      [reservePrefixIconWhitespace]="false"
      [htmlType]="'text'"
    ></app-editable-textual-input>

    <!-- LONGITUDE -->
    <app-editable-textual-input [formGroupNameRef]="fieldId"
      [fieldId]="'longitude'"
      [isFieldWithDataSource]="isFieldWithDataSource"
      [hasActiveConnection]="isFieldWithDataSource"
      [reservePrefixIconWhitespace]="false"
      [htmlType]="'text'"
    ></app-editable-textual-input>
  </div>
</div>